export default (() => {
  const onchange_proc = function (me, is_init) {
    const current = me
    const selector = '[data-tab=' + current.dataset.tabs + ']'
    const tabs = document.querySelectorAll(selector)
    const is_radio_or_checkbox =
      current.type === 'radio' || current.type === 'checkbox'
    tabs.forEach((tab) => {
      // hide if any of the following is true:
      // 1. radio or checkbox checked but not match current value
      // 2. radio or checkbox not checked but match current value
      // 3. not radio or checkbox and not match current value
      let match_value = tab.dataset.tabValue == current.value
      if (
        !is_init ||
        (!match_value && !is_radio_or_checkbox) ||
        (is_radio_or_checkbox && current.checked && !match_value) ||
        (is_radio_or_checkbox && !current.checked && match_value)
      ) {
        tab.style.display = 'none'
        tab
          .querySelectorAll(
            'input[data-required=true],select[data-required=true],textarea[data-required=true]'
          )
          .forEach((input) => {
            input.removeAttribute('required')
          })
      }
    })
    current
      .querySelectorAll(
        'input[data-required=true],select[data-required=true],textarea[data-required=true]'
      )
      .forEach((input) => {
        input.removeAttribute('required')
      })
    const value = is_radio_or_checkbox && !current.checked ? '' : current.value
    const tab = document.querySelector(
      selector + "[data-tab-value='" + value + "']"
    )
    if (tab) {
      tab.style.display = 'block'
      tab
        .querySelectorAll(
          'input[data-required=true],select[data-required=true],textarea[data-required=true]'
        )
        .forEach((input) => {
          input.setAttribute('required', 'required')
        })
    }
    /* else {
      console.log(selector + "[data-tab-value='" + value + "']")
    }*/
  }
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.js-on-change-tabs').forEach((element) => {
      onchange_proc(element, true)
      element.addEventListener('change', () => {
        onchange_proc(element, false)
      })
    })
  })
})()
